angular.module('tf.services')

    .factory('RenderService', ['HttpService','ProjectService','FarmerService','MixpanelService','NotificationService','Session','$q',
        function (HttpService, ProjectService, FarmerService, MixpanelService, NotificationService, Session, $q) {
            var service = {};

            service.render = function(watermark){
                if(validateProject(ProjectService.project)){
                    var cp = ProjectService.project.clean();
                    cp.watermark = !!watermark;
                    return HttpService.post("farmer/" + FarmerService.current().fid + "/render", {project : cp}, true).then(function (res) {
                        NotificationService.notify('produce-started-alert', {}, {x:true, duration : 3});
                    });
                } else {
                    return $q.reject({message : "Missing some required fields"});
                }

            };

            service.preview = function(template){
                if(validateTemplate(template)){
                    var cp = ProjectService.project.clean();
                    var tmp = template.clean();
                    if(tmp.preview === null){
                        tmp.preview = tmp.duration;
                    }
                    tmp.use = true;
                    cp.templates = [tmp];
                    return HttpService.post("farmer/" + FarmerService.current().fid + "/preview", { project: cp }, true);
                } else {
                    return $q.reject({message : "Missing some required fields"});
                }

            };


            var validateTemplate = function(template){
                var isValid = true;
                _.each(template.controls, function(control){
                    if(control.required && _.isEmpty(control.value.trim())){
                        control.invalid = true;
                        isValid = false;
                    } else {
                        delete control.invalid;
                    }
                    if(control.limit && control.value){
                        control.value = control.value.trim();
                    }
                });
                return isValid;
            };
            var validateProject = function(project){
                var isValid = true;
                _.each(project.templates, function(template){
                    if(template.use && !template.hide && !validateTemplate(template)){
                        isValid = false;
                    }
                });
                return isValid;
            };

            return service;
        }])
;
